import { render } from "./EditarConstrucaoEtapa.vue?vue&type=template&id=22e50d10"
import script from "./EditarConstrucaoEtapa.vue?vue&type=script&lang=js"
export * from "./EditarConstrucaoEtapa.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__